var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/informationrequest/viewmodels/index',["require", "exports", "common/viewmodelbase", "areas/informationrequest/models/bindable", "services/navigator", "areas/informationrequest/service/informationrequest-service", "models/account", "../../../common/string", "../../../common/constants", "areas/informationrequest/service/toastDCService"], function (require, exports, common, VM, Navigator, service, Account, String, constants, toastService) {
    "use strict";
    var InformationRequestViewModel = (function (_super) {
        __extends(InformationRequestViewModel, _super);
        // #region ctor
        function InformationRequestViewModel() {
            _super.call(this);
            this.clients = new Array();
            this.observableClients = ko.observableArray([]);
            this.originalClients = new Array();
            this.filters = new Array();
            this.selectedFilters = ko.observableArray([]);
            this.paginationText = ko.observable("");
            this.getMoreClients = ko.observable(false);
            this.displayLoading = ko.observable(false);
            this.showClearInput = ko.observable(false);
            this.allClientsRecived = false;
            this.getNextClientsSpiner = ko.observable(false);
            this.showLoadingSpinner = ko.observable(false);
            this.noClientsIcon = ko.observable(false);
            this.isAnyRequestToReview = ko.observable(false);
            this.displayMessageFeatureInDDR = ko.observable(false);
            this.checkAllYears = ko.observable(true);
            this.filterEmployee = ko.observable();
            this.filterStatus = ko.observable();
            this.eeFilterSearch = ko.observable("");
            this.eeFilterShow = ko.observable(false);
            this.requestFilterShow = ko.observable(false);
            this.filteredEmployees = ko.observable();
            this.requestStatuses = ko.observable();
            this.taxYearFilterShow = ko.observable(false);
            this.numberOfItemSelected = ko.observable();
            this.enableExportToExcel = ko.observable(true);
            ko.track(this, ["clients", "filters"]);
            this.informationrequestService = new service.InformationRequestService();
            this.toastDCService = new toastService.ToastDCService();
            //this.clients.
            //this.clients.extend  
            //multi select dropdownlist
            $(document).click(function (e) {
                if (!($(e.target).is("#dropdownlist-container") || $(e.target).closest("#dropdownlist-container").length))
                    $("#dropdownlist-container-child").hide();
            });
        }
        // #endregion
        InformationRequestViewModel.prototype.onActivated = function () {
            var _this = this;
            this.sortDirection = ko.observable("ASC");
            this.sortDirectionDate = ko.observable("");
            this.sortDirectionName = ko.observable("");
            this.sortDirectionAdvisorApproved = ko.observable("");
            this.sortDirectionClientProvided = ko.observable("");
            this.sortDirectionRequestStatus = ko.observable("");
            this.sortDirectionClientCode = ko.observable("");
            this.sortDirectionTaxYear = ko.observable("");
            this.sortColumn = "ClientName";
            this.loadData();
            this.SelectAll = ko.computed({
                owner: this,
                read: function () { return _this.selectedFilters().length == _this.filters.length; },
                write: function () { return _this.selectedFilters(_this.selectedFilters().length == _this.filters.length ? [] : _this.filters.slice(0)); }
            });
            this.selectedFilters.subscribe(function (newSelectedFilters) {
                _this.filterClients(newSelectedFilters);
            });
            this.observableClients = ko.observableArray(this.clients);
        };
        InformationRequestViewModel.prototype.loadData = function () {
            var _this = this;
            this.eeFilterShow(false);
            this.requestFilterShow(false);
            this.taxYearFilterShow(false);
            this.filterEmployee();
            this.selectedStatusId = "";
            this.filterStatus(null);
            this.populateTaxYearFilterList();
            this.sortColumn = "ClientName";
            this.sortDirection("ASC");
            this.searchInput = "";
            this.resetPagination();
            this.LoadRequestStatusFilter().then(function () {
                if (Account.Session.employeeFilter != null) {
                    _this.setFilterOnLastEmployee(Account.Session.employeeFilter);
                }
                else {
                    _this.CheckIfUserHasClients();
                }
            });
            this.resetSortDirection();
            this.employeeSearch();
        };
        InformationRequestViewModel.prototype.toggleFilter = function () {
            this.eeFilterShow(!this.eeFilterShow());
            if (this.eeFilterShow()) {
                document.getElementById("empsearch").focus();
            }
        };
        InformationRequestViewModel.prototype.toggleRequestFilter = function () {
            this.requestFilterShow(!this.requestFilterShow());
        };
        InformationRequestViewModel.prototype.showRequestFilter = function () {
            this.requestFilterShow(true);
        };
        InformationRequestViewModel.prototype.showTaxYearFilter = function () {
            this.taxYearFilterShow(true);
            if ($("#dropdownlist-container-child").attr('style')) {
                $("#dropdownlist-container-child").removeAttr("style");
            }
        };
        InformationRequestViewModel.prototype.removeText = function () {
            this.filterEmployee(null);
            this.eeFilterSearch("");
            this.employeeId = "";
            this.selectedEmp = "";
            this.filteredEmployees(null);
            this.getClients();
            this.showClearInput(false);
            document.getElementById("empsearch").focus();
        };
        InformationRequestViewModel.prototype.ClearFilter = function () {
            this.filterEmployee(null);
            this.eeFilterSearch("");
            this.employeeId = "";
            this.filteredEmployees(null);
            this.showClearInput(false);
            this.selectedEmp = "";
            Account.Session.employeeFilter = "";
            this.getClients();
        };
        InformationRequestViewModel.prototype.ClearRequestFilter = function () {
            this.filterStatus(null);
            this.eeFilterSearch("");
            this.selectedStatusId = "";
            Account.Session.requestStatusFilter = "";
            this.getClients();
        };
        InformationRequestViewModel.prototype.ClearYearFilter = function () {
            this.checkAllYears(true);
            this.numberOfItemSelected('');
            this.SelectAll(true);
            this.onBlurFuncForTaxYear();
        };
        InformationRequestViewModel.prototype.onBlurFunc = function (data, event) {
            console.log(event);
            var blockToggle = false;
            if (event.relatedTarget && event.relatedTarget.className == "information-request-eefilter-result") {
                var itemSelected = event.relatedTarget.innerText;
                var filteredEmpsArray = this.filteredEmployees();
                var selectedEmp = filteredEmpsArray.filter(function (k) { return k.name === itemSelected; })[0];
                this.selectEmployee(selectedEmp, data);
            }
            else if (event.relatedTarget && event.relatedTarget.className == "information-request-eefilter-clear") {
                this.removeText();
            }
            else if (this.eeFilterSearch() != this.selectedEmp) {
                this.ClearFilter();
                this.toggleFilter();
            }
            else if (event.relatedTarget && event.relatedTarget.className == "information-request-cursor-pointer") {
                this.eeFilterShow(true);
            }
            else
                this.toggleFilter();
        };
        InformationRequestViewModel.prototype.onBlurFuncForStatus = function (data, event) {
            if (!(event.relatedTarget && event.relatedTarget.className == "information-request-eefilter-result"))
                this.toggleRequestFilter();
        };
        InformationRequestViewModel.prototype.onBlurFuncForTaxYear = function () {
            this.taxYearFilterShow(false);
        };
        InformationRequestViewModel.prototype.LoadRequestStatusFilter = function () {
            var _this = this;
            var defer = Q.defer();
            this.informationrequestService.GetAllRequestStauses()
                .then(function (response) {
                if (response.length != 0) {
                    _this.requestStatuses(response);
                    // Check for Request status filter from querystring
                    var statusQueryString = constants.QueryString.getValueByParameterName('status');
                    if (!String.isNullOrEmpty(statusQueryString)) {
                        var requestStatusOption = ko.utils.arrayFirst(_this.requestStatuses(), function (item) {
                            return item.statusName === statusQueryString;
                        });
                        Account.Session.requestStatusFilter = (requestStatusOption !== undefined && requestStatusOption !== null) ? requestStatusOption.id : "";
                    }
                    if (!String.isNullOrEmpty(Account.Session.requestStatusFilter)) {
                        var selectedFilter = $.grep(_this.requestStatuses(), function (rs) { return rs.id == Account.Session.requestStatusFilter; });
                        if (selectedFilter != null && selectedFilter.length > 0)
                            _this.filterStatus(selectedFilter[0]);
                    }
                }
                defer.resolve(true);
            })
                .fail(function () {
                defer.reject(false);
            });
            return defer.promise;
        };
        InformationRequestViewModel.prototype.GetUserId = function () {
            var token = Account.Session.accessToken;
            var base64Url = token.split('.')[1];
            var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
            var jwt = JSON.parse(jsonPayload);
            var userId = "http://claims.addison.de/identityguid";
            return jwt[userId];
        };
        InformationRequestViewModel.prototype.CheckIfUserHasClients = function () {
            var _this = this;
            var userId = this.GetUserId();
            this.informationrequestService.GetClientForUser(userId, this.filterYears).then(function (response) {
                if (response.length != 0) {
                    _this.informationrequestService.GetEmployeeById(userId)
                        .then(function (secondResponse) {
                        if (secondResponse != null) {
                            var employeeName = secondResponse[0].name;
                            _this.filterEmployee(secondResponse[0]);
                            _this.eeFilterSearch(employeeName);
                            _this.selectedEmp = employeeName;
                            _this.filteredEmployees(null);
                            if (employeeName.length > 0) {
                                _this.showClearInput(true);
                            }
                            _this.employeeId = userId;
                            _this.getClients();
                        }
                    });
                }
                else {
                    _this.employeeId = "";
                    _this.filterEmployee(null);
                    _this.filteredEmployees(null);
                    _this.getClients();
                }
            });
        };
        InformationRequestViewModel.prototype.setFilterOnLastEmployee = function (id) {
            var _this = this;
            if (String.isNullOrEmpty(id)) {
                this.employeeId = "";
                this.showClearInput(false);
                this.getClients();
            }
            else {
                this.informationrequestService.GetEmployeeById(id)
                    .then(function (response) {
                    if (response != null) {
                        var employeeName = response[0].name;
                        _this.filterEmployee(response[0]);
                        _this.eeFilterSearch(employeeName);
                        _this.selectedEmp = employeeName;
                        _this.filteredEmployees(null);
                        _this.employeeId = id;
                        _this.showClearInput(true);
                        _this.getClients();
                        _this.employeeSearch(false);
                    }
                });
            }
        };
        InformationRequestViewModel.prototype.selectRequestStatus = function (status, parent) {
            this.resetPagination();
            parent.filterStatus(status);
            this.selectedStatusId = status.id;
            Account.Session.requestStatusFilter = status.id;
            parent.requestFilterShow(false);
            this.getClients();
        };
        InformationRequestViewModel.prototype.selectEmployee = function (employee, parent) {
            this.resetPagination();
            parent.filterEmployee(employee);
            this.employeeId = employee.id;
            Account.Session.employeeFilter = this.employeeId;
            parent.eeFilterShow(false);
            this.getClients();
            var name = employee.name;
            parent.eeFilterSearch(name);
            this.selectedEmp = name;
            parent.filteredEmployees(null);
            this.employeeSearch(false);
        };
        InformationRequestViewModel.prototype.employeeSearch = function (showList) {
            var _this = this;
            if (showList === void 0) { showList = true; }
            var filter = this.eeFilterSearch();
            if (filter.length > 0) {
                this.showClearInput(true);
            }
            else {
                this.showClearInput(false);
            }
            if (filter.toString().replace(" ", "").length >= 3) {
                this.informationrequestService.GetEmployeesFiltered(this.skipCount, this.takeCount, filter).then(function (response) {
                    if (showList) {
                        var removeEmptySpaceEmps = response.map(function (k) {
                            if (k.name[0] == " ") {
                                k.name = k.name.trim();
                            }
                            return k;
                        });
                        _this.filteredEmployees(removeEmptySpaceEmps);
                    }
                    else {
                        _this.filteredEmployees(null);
                    }
                });
            }
            else {
                this.filteredEmployees(null);
            }
            return true;
        };
        InformationRequestViewModel.prototype.getClients = function () {
            var _this = this;
            if (this.filterYears != null && this.filterYears != "") {
                if (!String.isNullOrEmpty(Account.Session.requestStatusFilter)) {
                    this.selectedStatusId = Account.Session.requestStatusFilter;
                }
                this.informationrequestService.GetClientsSortedByUser(this.employeeId, this.skipCount, this.takeCount, this.sortColumn, this.sortDirection(), this.searchInput, this.filterYears, this.selectedStatusId)
                    .then(function (response) {
                    if (response != null) {
                        _this.clients = [];
                        _this.totalRecords = response.totalRecords;
                        var start = _this.totalRecords != 0 ? _this.skipCount + 1 : _this.skipCount;
                        var end = (_this.skipCount + _this.takeCount) > _this.totalRecords ? _this.totalRecords : (_this.skipCount + _this.takeCount);
                        _this.paginationText(start + " - " + end + " / " + _this.totalRecords);
                        for (var k = 0; k < response.records.length; k++) {
                            var client1 = new VM.Client();
                            client1.clientName = response.records[k].clientName;
                            client1.clientCode = response.records[k].clientCode;
                            client1.approvedCount = response.records[k].approvedCount;
                            client1.unapprovedCount = response.records[k].unapprovedCount;
                            client1.clientCompleted = response.records[k].clientCompleted;
                            client1.requestStatusId = response.records[k].requestStatusId;
                            client1.requestStatusName = response.records[k].requestStatusName;
                            client1.latestComments = response.records[k].latestComments;
                            client1.index(k + 1);
                            client1.clientGuid = response.records[k].clientGuid;
                            client1.taxYear = response.records[k].taxYear;
                            client1.taxYearDisplay = response.records[k].taxYear - 1 + "/" + response.records[k].taxYear;
                            client1.dateReceived = response.records[k].received;
                            client1.progress = client1.unapprovedCount + " incomplete ";
                            client1.HmrcData = response.records.hmrcData;
                            client1.isRead = response.records[k].isRead;
                            var date = new Date(Date.parse(response.records[k].received));
                            client1.received = date.toLocaleString('en-GB');
                            client1.setRequestStatusIconPath();
                            _this.clients.push(client1);
                        }
                        _this.showLoadingSpinner(false);
                        if (end == _this.totalRecords)
                            _this.allClientsRecived = true;
                        else
                            _this.allClientsRecived = false;
                        if (response.isAnyRequestToReview)
                            _this.isAnyRequestToReview(true);
                        else
                            _this.isAnyRequestToReview(false);
                        if (response.displayMessageFeatureInDDR)
                            _this.displayMessageFeatureInDDR(true);
                        else
                            _this.displayMessageFeatureInDDR(false);
                        if (_this.clients.length == 0)
                            _this.noClientsIcon(true);
                        else
                            _this.noClientsIcon(false);
                        if (_this.clients.length == 0)
                            _this.enableExportToExcel(false);
                        else
                            _this.enableExportToExcel(true);
                    }
                }).fail(function (response) {
                    _this.noClientsIcon(true);
                });
            }
            else {
                if (this.filterYears == "") {
                    this.clients = [];
                    this.noClientsIcon(true);
                    this.enableExportToExcel(false);
                    //Added below code for resetting paginationText when no data found 
                    this.paginationText(0 + " - " + 0 + " / " + 0);
                }
            }
        };
        InformationRequestViewModel.prototype.exportToExcel = function () {
            var _this = this;
            this.skipCount = 0;
            this.takeCount = 100000;
            var date = new Date();
            var month = date.getUTCMonth() + 1; //months from 1-12
            var day = date.getUTCDate();
            var year = date.getUTCFullYear();
            var newdate = day + "-" + month + "-" + year;
            var email = Account.Principal.current.loginName;
            var userName = email.substring(0, email.indexOf('@'));
            var downloadFileName = userName + "_" + newdate + ".xlsx";
            if (!this.displayLoading())
                this.displayLoading(true);
            this.informationrequestService.ExportToExcel(this.employeeId, this.skipCount, this.takeCount, this.sortColumn, this.sortDirection(), this.searchInput, this.filterYears, this.selectedStatusId)
                .then(function (response) {
                if (response != null) {
                    var baseobject = _this.base64ToBlob(response, "application/xlsx", 512);
                    var url = window.URL.createObjectURL(baseobject);
                    var a = document.createElement('a');
                    a.style.display = 'none';
                    a.href = url;
                    a.download = downloadFileName;
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(url);
                    _this.displayLoading(false);
                }
                else {
                    _this.toastDCService.constructDCToast('fail', "Error while generating excel.");
                    _this.displayLoading(false);
                }
            }).fail(function (response) {
                _this.toastDCService.constructDCToast('fail', "Error while generating excel.");
                _this.displayLoading(false);
            });
        };
        InformationRequestViewModel.prototype.base64ToBlob = function (base64, mimetype, slicesize) {
            mimetype = mimetype || '';
            slicesize = slicesize || 512;
            var bytechars = atob(base64);
            var bytearrays = [];
            for (var offset = 0; offset < bytechars.length; offset += slicesize) {
                var slice = bytechars.slice(offset, offset + slicesize);
                var bytenums = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    bytenums[i] = slice.charCodeAt(i);
                }
                var bytearray = new Uint8Array(bytenums);
                bytearrays[bytearrays.length] = bytearray;
            }
            return new Blob(bytearrays, { type: mimetype });
        };
        // #region sort
        InformationRequestViewModel.prototype.sortOnDate = function () {
            this.sortColumn = "Received";
            if (this.sortDirectionDate() == "desc") {
                this.sortDirectionDate("");
                return;
            }
            else if (this.sortDirectionDate() == "") {
                this.sortDirectionDate("asc");
            }
            else if (this.sortDirectionDate() == "asc") {
                this.sortDirectionDate("desc");
            }
            this.sortDirection(this.sortDirectionDate().toUpperCase());
            this.resetPagination();
            this.getClients();
            this.sortDirectionAdvisorApproved("");
            this.sortDirectionClientProvided("");
            this.sortDirectionRequestStatus("");
            this.sortDirectionName("");
            this.sortDirectionClientCode("");
            this.sortDirectionTaxYear("");
        };
        InformationRequestViewModel.prototype.sortOnClientName = function () {
            this.sortColumn = "ClientName";
            if (this.sortDirectionName() == "desc") {
                this.sortDirectionName("");
                return;
            }
            else if (this.sortDirectionName() == "") {
                this.sortDirectionName("asc");
            }
            else if (this.sortDirectionName() == "asc") {
                this.sortDirectionName("desc");
            }
            this.sortDirection(this.sortDirectionName().toUpperCase());
            this.resetPagination();
            this.getClients();
            this.sortDirectionDate("");
            this.sortDirectionAdvisorApproved("");
            this.sortDirectionClientProvided("");
            this.sortDirectionRequestStatus("");
            this.sortDirectionClientCode("");
            this.sortDirectionTaxYear("");
        };
        InformationRequestViewModel.prototype.sortOnAdvisorApproved = function () {
            this.sortColumn = "UnapprovedCount";
            if (this.sortDirectionAdvisorApproved() == "desc") {
                this.sortDirectionAdvisorApproved("");
                return;
            }
            else if (this.sortDirectionAdvisorApproved() == "") {
                this.sortDirectionAdvisorApproved("asc");
            }
            else if (this.sortDirectionAdvisorApproved() == "asc") {
                this.sortDirectionAdvisorApproved("desc");
            }
            this.sortDirection(this.sortDirectionAdvisorApproved().toUpperCase());
            this.resetPagination();
            this.getClients();
            this.sortDirectionDate("");
            this.sortDirectionName("");
            this.sortDirectionClientCode("");
            this.sortDirectionTaxYear("");
            this.sortDirectionClientProvided("");
            this.sortDirectionRequestStatus("");
        };
        InformationRequestViewModel.prototype.sortOnClientProvided = function () {
            this.sortColumn = "ClientCompleted";
            if (this.sortDirectionClientProvided() == "desc") {
                this.sortDirectionClientProvided("");
                return;
            }
            else if (this.sortDirectionClientProvided() == "") {
                this.sortDirectionClientProvided("asc");
            }
            else if (this.sortDirectionClientProvided() == "asc") {
                this.sortDirectionClientProvided("desc");
            }
            this.sortDirection(this.sortDirectionClientProvided().toUpperCase());
            this.resetPagination();
            this.getClients();
            this.sortDirectionDate("");
            this.sortDirectionName("");
            this.sortDirectionClientCode("");
            this.sortDirectionTaxYear("");
            this.sortDirectionAdvisorApproved("");
            this.sortDirectionRequestStatus("");
        };
        InformationRequestViewModel.prototype.sortOnRequestStatus = function () {
            this.sortColumn = "RequestStatus";
            if (this.sortDirectionRequestStatus() == "desc") {
                this.sortDirectionRequestStatus("");
                return;
            }
            else if (this.sortDirectionRequestStatus() == "") {
                this.sortDirectionRequestStatus("asc");
            }
            else if (this.sortDirectionRequestStatus() == "asc") {
                this.sortDirectionRequestStatus("desc");
            }
            this.sortDirection(this.sortDirectionRequestStatus().toUpperCase());
            this.resetPagination();
            this.getClients();
            this.sortDirectionDate("");
            this.sortDirectionName("");
            this.sortDirectionClientCode("");
            this.sortDirectionTaxYear("");
            this.sortDirectionAdvisorApproved("");
            this.sortDirectionClientProvided("");
        };
        InformationRequestViewModel.prototype.sortOnClientCode = function () {
            this.sortColumn = "ClientCode";
            if (this.sortDirectionClientCode() == "desc") {
                this.sortDirectionClientCode("");
                return;
            }
            else if (this.sortDirectionClientCode() == "") {
                this.sortDirectionClientCode("asc");
            }
            else if (this.sortDirectionClientCode() == "asc") {
                this.sortDirectionClientCode("desc");
            }
            this.sortDirection(this.sortDirectionClientCode().toUpperCase());
            this.resetPagination();
            this.getClients();
            this.sortDirectionDate("");
            this.sortDirectionName("");
            this.sortDirectionAdvisorApproved("");
            this.sortDirectionClientProvided("");
            this.sortDirectionRequestStatus("");
            this.sortDirectionTaxYear("");
        };
        InformationRequestViewModel.prototype.sortOnTaxYear = function () {
            this.sortColumn = "TaxYear";
            if (this.sortDirectionTaxYear() == "desc") {
                this.sortDirectionTaxYear("");
                return;
            }
            else if (this.sortDirectionTaxYear() == "") {
                this.sortDirectionTaxYear("asc");
            }
            else if (this.sortDirectionTaxYear() == "asc") {
                this.sortDirectionTaxYear("desc");
            }
            this.sortDirection(this.sortDirectionTaxYear().toUpperCase());
            this.resetPagination();
            this.getClients();
            this.sortDirectionDate("");
            this.sortDirectionName("");
            this.sortDirectionAdvisorApproved("");
            this.sortDirectionClientProvided("");
            this.sortDirectionRequestStatus("");
            this.sortDirectionClientCode("");
        };
        InformationRequestViewModel.prototype.resetSortDirection = function () {
            this.sortDirectionDate("");
            this.sortDirectionName("");
            this.sortDirectionAdvisorApproved("");
            this.sortDirectionClientProvided("");
            this.sortDirectionRequestStatus("");
            this.sortDirectionClientCode("");
            this.sortDirectionTaxYear("");
        };
        // #endregion
        // #region filter
        InformationRequestViewModel.prototype.populateTaxYearFilterList = function () {
            var _this = this;
            var allFilters = new Array();
            this.filters = [];
            this.filterYears = "";
            this.selectedFilters.removeAll();
            var date = new Date();
            for (var year = 2018; year <= date.getFullYear() + 2; year++) {
                var filter = new VM.FilterTaxYear();
                filter.text = (year - 1) + "/" + year;
                this.filters.push(filter);
                allFilters.push(filter);
                this.filterYears = this.filterYears + year;
            }
            this.filters.sort(function (n1, n2) { return _this.sortArrayDesc(n1, n2); });
            allFilters.sort(function (n1, n2) { return _this.sortArrayDesc(n1, n2); });
            this.selectedFilters = ko.observableArray(allFilters);
        };
        InformationRequestViewModel.prototype.filterClients = function (newSelectedFilters) {
            this.filterYears = "";
            if (newSelectedFilters.length > 0)
                this.numberOfItemSelected(newSelectedFilters.length.toString() + " Year(s)");
            else
                this.numberOfItemSelected("Select Year(s)");
            for (var i = 0; i < newSelectedFilters.length; i++) {
                this.filterYears = this.filterYears + newSelectedFilters[i].text.substr(5, 4);
            }
            this.resetPagination();
            if (newSelectedFilters.length == 0)
                this.showLoadingSpinner(false);
            this.getClients();
        };
        InformationRequestViewModel.prototype.FilterAllTaxYearsPresent = function () {
            return this.SelectAll();
        };
        InformationRequestViewModel.prototype.togleAllYears = function () {
            if (this.checkAllYears())
                this.SelectAll();
            this.checkAllYears(!this.checkAllYears());
        };
        // #endregion
        // #region search
        InformationRequestViewModel.prototype.searchClients = function () {
            this.resetPagination();
            this.getClients();
        };
        // #endregion
        // #region pagination
        InformationRequestViewModel.prototype.nextPage = function () {
            if (!this.allClientsRecived) {
                this.skipCount = this.skipCount + this.takeCount;
                this.getNextClientsSpiner(true);
                this.getClients();
            }
            this.getNextClientsSpiner(false);
        };
        InformationRequestViewModel.prototype.previousPage = function () {
            if (this.skipCount - this.takeCount >= 0) {
                this.allClientsRecived = false;
                this.skipCount = this.skipCount - this.takeCount;
                this.getNextClientsSpiner(true);
                this.getClients();
            }
            this.getNextClientsSpiner(false);
        };
        InformationRequestViewModel.prototype.firstPage = function () {
            this.resetPagination();
            this.getClients();
            this.getNextClientsSpiner(false);
            this.showLoadingSpinner(false);
        };
        InformationRequestViewModel.prototype.lastPage = function () {
            if (!this.allClientsRecived) {
                this.skipCount = this.totalRecords - (this.totalRecords % this.takeCount);
                this.getNextClientsSpiner(true);
                this.getClients();
            }
            this.getNextClientsSpiner(false);
        };
        InformationRequestViewModel.prototype.resetPagination = function () {
            this.noClientsIcon(false);
            this.showLoadingSpinner(true);
            this.allClientsRecived = false;
            this.skipCount = 0;
            this.takeCount = 100;
        };
        // #endregion
        InformationRequestViewModel.prototype.rowClicked = function (client) {
            var params = [];
            params.push(new Navigator.NavigationParameter("clientGuid", client.clientGuid));
            params.push(new Navigator.NavigationParameter("taxYear", client.taxYear));
            Navigator.navigateTo("informationrequest", "clientDetails", "/clientDetails", null, params);
        };
        InformationRequestViewModel.prototype.sortArrayDesc = function (n1, n2) {
            if (n1.text > n2.text) {
                return -1;
            }
            if (n1.text < n2.text) {
                return 1;
            }
            return 0;
        };
        InformationRequestViewModel.prototype.mouseOverRoot = function (section) {
            section.mouseOver(true);
        };
        InformationRequestViewModel.prototype.mouseOutRoot = function (section) {
            section.mouseOver(false);
        };
        return InformationRequestViewModel;
    }(common.ListViewModelBase));
    var instance = new InformationRequestViewModel();
    return instance;
});

